import { restoreFromLocalStorage } from "@/lib/restoreFromLocalStorage";
import { Action, Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";
import store from "../VuexPlugin";

@Module({
  dynamic: true,
  namespaced: true,
  name: "bookingCreateStore",
  store
})
export class BookingCreateStore extends VuexModule {
  _rwg_token: string | null = restoreFromLocalStorage("_rwg_token", "bookingCreateStore", null);

  _rwg_time: number | null = restoreFromLocalStorage("_rwg_time", "bookingCreateStore", null);

  get rwgToken() {
    return this._rwg_token;
  }

  get rwgTime() {
    return this._rwg_time;
  }

  @Mutation
  updateRwgToken(rwgToken: string | null) {
    if (rwgToken && this._rwg_token !== rwgToken) {
      this._rwg_time = new Date().getTime();
    }

    this._rwg_token = rwgToken;
  }

  @Action
  setRwgToken(rwgToken: string) {
    this.context.commit("updateRwgToken", rwgToken);
  }
}

export const BookingCreateModule = getModule(BookingCreateStore);
